<template>
  <div class="chat-widget">
    <Toast position="top-right" group="default" />
    <ConfirmDialog />
    <div>
      <ChatHeader/>
      <ProgressBar class="chat-widget__loading-progress" mode="indeterminate" v-if="appStateStore.blockSending" style="height: 6px; width: 100%"></ProgressBar>
      <Divider class="chat-widget__divider" v-else/>
    </div>
    <ChatWrapper/>
    <ChatFooter/>
  </div>
</template>

<script setup>
import Toast from 'primevue/toast';
import Divider from 'primevue/divider';
import ProgressBar from 'primevue/progressbar';
import {onMounted} from "vue";
import {useToastStore} from "@/modules/chat/stores/toast";
import ConfirmDialog from "primevue/confirmdialog";
import ChatHeader from "@/modules/chat/components/header/ChatHeader.vue";
import ChatWrapper from "@/modules/chat/components/ChatWrapper.vue";
import ChatFooter from "@/modules/chat/components/footer/ChatFooter.vue";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import '@/modules/chat/assets/styles';
import '@/modules/chat/assets/prizm';

const appStateStore = useAppStateStore();
const toastStore = useToastStore();

onMounted(async () => {
  await toastStore.init();
  await appStateStore.initializeApp();
});
</script>

<style>
</style>